/* 2026-10-25 (Claude). Joel: "Yes, move the remaining shared inline blocks into cached asset files the same way, and measure before and after".
   Moved out of snippets/aoam-setup-addons.liquid so browsers cache it instead of downloading it inside every page. Same code as the inline copy it replaced, notes kept as comments (the CDN strips them).
   Edit THIS file now. Roll back: restore snippets/aoam-setup-addons.liquid from OneDrive/Documents/AOAM-Theme-Backups/2026-10-25-inline-move/ and delete this file. */
(function(){
  if (window.__aoamSetup) return; window.__aoamSetup = 1;
  var PLUS = '<svg viewBox="0 0 18 18" aria-hidden="true"><path d="M9 3v12M3 9h12" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>';
  var TICK = '<svg viewBox="0 0 18 18" aria-hidden="true"><path d="M3.5 9.5l3.5 3.5 7.5-8" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function picked(){
    var out = [], ins = document.querySelectorAll('input[type="radio"][data-variant-input]:checked, select[data-variant-input]');
    for (var i = 0; i < ins.length; i++) out.push(ins[i].value);
    return out;
  }
  function sync(){
    var sel = picked(); if (!sel.length) return;
    var rows = document.querySelectorAll('.aoam-bwpair__r[data-setup-vars]');
    for (var i = 0; i < rows.length; i++) {
      var r = rows[i], vars;
      try { vars = JSON.parse(r.getAttribute('data-setup-vars')); } catch (x) { continue; }
      var best = null, bs = -1;
      for (var j = 0; j < vars.length; j++) {
        var s = 0; for (var k = 0; k < vars[j].o.length; k++) if (sel.indexOf(vars[j].o[k]) > -1) s++;
        if (s > bs) { bs = s; best = vars[j]; }
      }
      if (!best) continue;
      r.querySelector('.aoam-bwpair__add').setAttribute('data-variant-id', best.id);
      var v = r.querySelector('.aoam-bwpair__v'); if (v) v.textContent = best.l;
      r.querySelector('.aoam-bwpair__p').innerHTML = (best.c ? '<s>' + best.c + '</s>' : '') + '<span>' + best.p + '</span>';
    }
  }
  document.addEventListener('change', function(e){ if (e.target && e.target.matches && e.target.matches('[data-variant-input]')) setTimeout(sync, 0); }, true);
  document.addEventListener('click', function(e){
    var b = e.target && e.target.closest && e.target.closest('.aoam-bwpair__add');
    if (!b || b.disabled) return;
    e.preventDefault();
    var id = parseInt(b.getAttribute('data-variant-id'), 10); if (!id) return;
    b.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
      .then(function(r){ return r.json().then(function(j){ return { ok: r.ok, j: j }; }); })
      .then(function(res){
        if (!res.ok) {
          b.disabled = false;
          try { if (window.aoamCartAnnounce) window.aoamCartAnnounce((res.j && res.j.description) || 'That item could not be added to your cart.'); } catch (x) {}
          return;
        }
        b.classList.add('is-added'); b.innerHTML = TICK;
        var t = document.querySelector('[data-header-cart-trigger]'); if (t) t.click();
        try { document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: {} })); } catch (x) {}
        setTimeout(function(){ b.classList.remove('is-added'); b.innerHTML = PLUS; b.disabled = false; }, 1600);
      })
      .catch(function(){ b.disabled = false; });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
})();
